import React from 'react';
import { Icon } from '@vectord/components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './ToggleChip.module.scss';

export default function ToggleChip({
  isAdded = false,
  onAdd,
  onRemove,
  label,
  className,
  labelClassName,
  iconClassName,
}) {
  return (
    <div
      className={classNames(
        styles.root,
        { [styles.active]: isAdded },
        className
      )}
    >
      <div className={labelClassName}>{label}</div>
      {isAdded ? (
        <Icon
          name="close"
          onClick={onRemove}
          className={classNames('m-l-xs cursor', iconClassName)}
        />
      ) : (
        <Icon
          name="add"
          onClick={onAdd}
          className={classNames('m-l-xs cursor', iconClassName)}
        />
      )}
    </div>
  );
}

ToggleChip.propTypes = {
  isAdded: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  iconClassName: PropTypes.string,
};
